package ca.northroot.app.data

import kotlinx.serialization.Serializable

@Serializable
data class FirebaseTimestamp(
    val seconds: Long = 0,
    val nanoseconds: Int = 0
) {
    fun toEpochMilliseconds(): Long = seconds * 1000 + (nanoseconds / 1000000)
}
